import { Group } from '@mantine/core';
import { UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { technologicalTransferResults } from '@/module/Author/TechnologicalTransfer';
import { TechnologicalTransferSchema } from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferSchema';

import { EnumMultiSelectControl, TextInputControl } from '@/core/components';

export interface TechnologicalTransferResultSelectControlProps {
  isSubmitting: boolean;
  watch: UseFormWatch<TechnologicalTransferSchema>;
}

export const TechnologicalTransferResultSelectControl = (props: TechnologicalTransferResultSelectControlProps) => {
  const { isSubmitting, watch } = props;
  const { t } = useTranslation();

  const resultField = watch('results');
  const showResultNameField = resultField?.includes('R0_OTHER');

  return (
    <Group>
      <EnumMultiSelectControl<TechnologicalTransferSchema>
        withAsterisk
        name="results"
        label={t('technologicalTransfers.form.fields.results')}
        isSubmitting={isSubmitting}
        options={technologicalTransferResults.map(type => ({
          value: type,
          label: t(`technologicalTransfers.resultsEnum.${type}`),
        }))}
      />
      {showResultNameField && (
        <TextInputControl<TechnologicalTransferSchema>
          withAsterisk
          name="resultName"
          label={t('technologicalTransfers.form.fields.resultName')}
          isSubmitting={isSubmitting}
        />
      )}
    </Group>
  );
};
